import type { RosterFilter } from "../../camp-api/csv";

// Every camp-portal key starts with ["camp-portal", organizerId] so a mutation can invalidate one
// organizer's whole cache (or one slice of it) with a prefix.
export const campPortalQueryKeys = {
	campPortal: {
		all: () => ["camp-portal"] as const,
		camp: (organizerId: string, campId: string) =>
			["camp-portal", organizerId, "camp", campId] as const,
		/** Every camps list of an organizer, whatever the status filter. */
		campLists: (organizerId: string) => ["camp-portal", organizerId, "camps"] as const,
		camps: (organizerId: string, status?: string) =>
			["camp-portal", organizerId, "camps", status ?? "all"] as const,
		edition: (organizerId: string, editionId: string) =>
			["camp-portal", organizerId, "edition", editionId] as const,
		editions: (organizerId: string, campId: string) =>
			["camp-portal", organizerId, "editions", campId] as const,
		members: (organizerId: string) => ["camp-portal", organizerId, "members"] as const,
		organizers: () => ["camp-portal", "organizers"] as const,
		roster: (organizerId: string, editionId: string, filter: RosterFilter) =>
			["camp-portal", organizerId, "roster", editionId, filter] as const,
		/** Every filter of one edition's roster: what a registration change makes stale. */
		rosters: (organizerId: string, editionId: string) =>
			["camp-portal", organizerId, "roster", editionId] as const,
	},
} as const;
